"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useLanguage = require("./useLanguage");
Object.keys(_useLanguage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLanguage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useLanguage[key];
    }
  });
});
var _useTranslationsFromNamespace = require("./useTranslationsFromNamespace");
Object.keys(_useTranslationsFromNamespace).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslationsFromNamespace[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslationsFromNamespace[key];
    }
  });
});
var _useTranslationsWithNamespaces = require("./useTranslationsWithNamespaces");
Object.keys(_useTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslationsWithNamespaces[key];
    }
  });
});
